// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-page__container[data-v-4eab46ee]{align-items:center;display:flex;flex-direction:column;gap:20px;height:100vh;justify-content:center;padding:80px 0 200px;width:100%}.loading-page__info[data-v-4eab46ee]{color:#fff;font-weight:500;max-width:330px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
